import React from 'react'
import { Link } from 'react-router-dom'
import { map } from 'lodash'

import useProfilePosts from '../hooks/useProfilePosts'

import { Button, ListLink } from '../components/styled'

const UserProfileTab = ({ view }) => {
  const { posts, showMore } = useProfilePosts({ view })

  return (
    <>
      <ul>
        {map(posts, showPost => (
          <ListLink key={showPost.id}>
            <Link to={`/postulation/${showPost.id}`}> {showPost.title || showPost.postTitle}</Link>
          </ListLink>
        ))}
      </ul>
      <Button onClick={showMore} disabled={!showMore}>More {view}</Button>
    </>
  )
}

export default UserProfileTab
